import { Controller } from "@hotwired/stimulus";

// The admin cancellation's gateway refund is capped at the credit, so the
// refund checkbox is only live once there is a credit to refund (GR-3808).
export class RefundNeedsCreditController extends Controller {
  static targets = ["credit", "refund"];

  // Browsers restore a typed credit (and the box's ticked state) on
  // Back/reload; enable the server-rendered box to match, but keep whatever
  // ticked state the browser restored.
  connect() {
    if (!this.hasRefundTarget) return;

    const restoredChecked = this.refundTarget.checked;
    this.update();
    if (!this.refundTarget.disabled) this.refundTarget.checked = restoredChecked;
  }

  creditFull({ params: { fullAmount } }) {
    this.creditTarget.value = fullAmount;
    this.update();
  }

  update() {
    if (!this.hasRefundTarget) return;

    const hasCredit = parseFloat(this.creditTarget.value) > 0;
    const wasDisabled = this.refundTarget.disabled;

    this.refundTarget.disabled = !hasCredit;
    if (!hasCredit) this.refundTarget.checked = false;
    // Tick it as it becomes available, matching the policy-credit default, but
    // leave an admin's own untick alone after that.
    else if (wasDisabled) this.refundTarget.checked = true;
  }
}
